import { Error, Info, Warning } from "@mui/icons-material";
import { Box, Card, Link } from "@mui/material";
import PageTitleSubtitle from "../PageTitleSubTitle";
import localize from "../../common/localize";

export default function NotificationItem({
  notification,
  onNotificationClick,
}) {
  const getNotificationIcon = (notification) => {
    switch (notification.severity) {
      default:
        return (
          <Info
            className="info_icon_color"
            sx={{ width: "24px", height: "24px" }}
          />
        );

      case 1:
        return (
          <Warning
            className="warning_icon_color"
            sx={{ color: "", width: "24px", height: "24px" }}
          />
        );

      case 2:
        return (
          <Error
            className="error_icon_color"
            sx={{ color: "", width: "24px", height: "24px" }}
          />
        );
    }
  };

  return (
    <Card
      key={notification.id}
      variant="outlined"
      style={{
        borderRadius: "5px",
        cursor: notification.unread ? "pointer" : "default",
        backgroundColor: notification.unread ? "#aed2ef" : "white",
      }}
      className="flex gap-2 w-full justify-center p-2"
      onClick={
        notification.unread
          ? () => {
              onNotificationClick(notification);
            }
          : undefined
      }
    >
      {getNotificationIcon(notification)}
      <Box className="flex flex-col gap-2 w-full">
        <PageTitleSubtitle
          useFieldTitleStyle
          useEventTitleStyle
          title={notification.title}
          subtitle={notification.message}
        />

        {notification?.Event && (
          <Box className="flex mt-2 gap-2 w-full items-center">
            <label className="text-xs">
              <b>{localize.event}:</b>
            </label>
            <Link
              className="text-xs"
              color="primary"
              underline="always"
              href="#"
              onClick={() => {
                window.open(
                  `/events/detail/${notification.Event.Id}`,
                  "_blank"
                );
              }}
            >{`${notification.Event.Code}`}</Link>
          </Box>
        )}
      </Box>
    </Card>
  );
}
